<template>
  <div id="main-content" class="detail-drop-route">
    <el-col :offset="1" :span="22">
      <PageTitle :title="title" :backLink="backLink"></PageTitle>
      <el-row>
        <el-form :inline="true" class="demo-form-inline">
          <el-form-item>
            <el-button type="success" @click="goToEdit()">{{ $t('common.edit') }}</el-button>
          </el-form-item>
        </el-form>
      </el-row>
      <form>
        <el-row>
          <el-col :span="11" style="display: inline">
            <span class="form-lable">{{ $t('common.drop_route_name') }}:</span>
            <span class="info-span"> {{ dropRouteInfo.name }} </span>
          </el-col>
<!--          <el-col :offset="1" :span="12" style="display: inline">-->
<!--            <span class="form-lable">{{ $t('common.color') }}:</span>-->
<!--            <span class="info-span" style="width: 30%"> {{ dropRouteInfo.color }} </span>-->
<!--            <span :style="{backgroundColor: `${dropRouteInfo.color}`}" style="width: 20px; float: left; height: 38px;"></span>-->
<!--          </el-col>-->
        </el-row>

        <el-row>
          <el-col :span="11">
            <el-row class="row-section">
              <h3>{{ $t('bus_stop.bus_stop_list') }}</h3>
            </el-row>
            <el-row style="padding-top: 20px">
              <table class="bus-list">
                <tr>
                  <th width="5%">#</th>
                  <th width="40%">{{ $t('common.bus_stop') }}</th>
                  <th width="40%">{{ $t('common.address') }}</th>
<!--                  <th>{{ $t('route.duration_time') }}</th>-->
                </tr>
                <tr v-for="(place, index) in dropRouteInfo.place_list" :key="place.id">
                  <td>{{ index + 1 }}</td>
                  <td>{{ place.name }}</td>
                  <td>{{ place.address }}</td>
<!--                  <td>{{ parseInt(place.duration) }}</td>-->
                </tr>
              </table>
            </el-row>
          </el-col>
        </el-row>
      </form>
    </el-col>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import PageTitle from '@/components/PageTitle'

  export default {
    name: "DetailDropRoute",
    components: {
      PageTitle
    },
    data: function () {
      return {
        title: 'route.drop_route_information',
        backLink: `/drop-route?action=back`}
    },
    mounted: function () {
      let successCallback = () => {
      };
      let payload = {
        successCallback,
        drop_route_id: this.$route.query.drid
      }
      this.$store.dispatch('droproute/getDropRouteInfo', payload)
    },
    computed: {
      ...mapState('droproute', ['dropRouteInfo']),
    },
    methods: {
      goToEdit: function () {
        this.$router.push({path: '/drop-route/edit', query: {drid: this.$route.query.drid}});
      },
      goToRegist: function () {
        this.$router.push({path: '/drop-route/update-schedule', query: {drid: this.$route.query.drid}});
      }
    }
  }
</script>

<style lang="scss">
</style>
